import * as actionTypes from "../../../actionTypes";
import * as api from "../../../../api/index";
import { toast } from "react-toastify";

// Saves an entire (service id + fee name) ladder in one request. The backend
// replaces just that lane atomically, so a mid-ladder insert cannot leave the
// table half-updated. Returns true on success so the caller can close its modal
// only when the write actually landed.
const saveLadder = (apiCall) => (tenantId, formData, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await apiCall(tenantId, formData);
    if (status === 202) {
      toast.success(data.message);
      setLoading(false);
      return true;
    }
    dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    setLoading(false);
    return false;
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(false);
    return false;
  }
};

export const SaveInternationalServiceFeeLadderBIZcore =
  saveLadder((tenantId, form) => api.saveInternationalServiceFeeLadderBIZcore(tenantId, form));

export const SaveInternationalUSDtoUSDServiceFeeLadderBIZcore =
  saveLadder((tenantId, form) => api.saveInternationalUSDtoUSDServiceFeeLadderBIZcore(tenantId, form));
